module.exports = __webpack_public_path__ + "static/media/S3N8.fa1360d1.svg";